@if (shippingInformation) {
<section
    class="product-shipping-information"
    [class.background-display]="showBackground"
    [attr.aria-labelledby]="'shipping'">
    <span
        id="shipping"
        hSrOnlyNoSnippet
        role="heading"
        i18n-role
        aria-level="4"
        i18n="@@hermes.accessibility.product-info.shipping-information">
        Shipping information
    </span>
    <p class="shipping-information" [innerHTML]="shippingInformation"></p>
</section>
}
